import OrderMainPage from "./main.container";

export default OrderMainPage;
